<template>
  <div v-if="tagSearchKeywordList.length && !isVisibleRecommendTagKeyword">
    <tag-search-result-band :searchResult="programTagSearchResult" type="program" :change-tag-tab="changeTagTab"
                            v-if="programTagSearchResult && programTagSearchResult.count && currentTagSearchResultTab === 'all'"
                            :key="'program_tag_result' + programTagSearchResult.count + '_' + tagSearchKeywordList.length">
    </tag-search-result-band>
    <tag-search-result-band :searchResult="vodTagSearchResult" type="vod" :change-tag-tab="changeTagTab"
                            v-if="vodTagSearchResult && vodTagSearchResult.count && currentTagSearchResultTab === 'all'"
                            :key="'vod_tag_result' + vodTagSearchResult.count + '_' + tagSearchKeywordList.length">
    </tag-search-result-band>
    <tag-search-result-band :searchResult="movieTagSearchResult" type="movie" :change-tag-tab="changeTagTab"
                            v-if="movieTagSearchResult && movieTagSearchResult.count && currentTagSearchResultTab === 'all'"
                            :key="'movie_tag_result' + movieTagSearchResult.count + '_' + tagSearchKeywordList.length">
    </tag-search-result-band>
    <tag-search-result-list v-if="currentTagSearchResultTab !== 'all'" :total-count="getTotalCount"
                            :tag-search-keyword-list="tagSearchKeywordList" :type="currentTagSearchResultTab"
                            :key="'list' + currentTagSearchResultTab + getTotalCount"></tag-search-result-list>
    <div v-if="currentTagSearchResultTab === 'all' && getTotalCount === 0" class="empty-cell-list">
      <div class="attention-mark-area">
        <EmptyIcon />
      </div>
      <div class="text-area">
        선택한 태그 검색결과가 없어요.<br/>
        다른 태그를 선택해보세요.
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import TagSearchResultBand from '@/components/search/TagSearchResultBand'
import TagSearchResultList from '@/components/search/TagSearchResultList'
import EmptyIcon from '@/assets/svg/common/img_empty.svg'
export default {
  name: 'TagSearchResultBandView',
  components: {
    EmptyIcon,
    TagSearchResultBand,
    TagSearchResultList
  },
  methods: {
    ...mapMutations(['changeTagTab'])
  },
  computed: {
    ...mapGetters(['tagSearchKeywordList', 'isVisibleRecommendTagKeyword', 'currentTagSearchResultTab',
      'programTagSearchResult', 'vodTagSearchResult', 'movieTagSearchResult' ]),
    getTotalCount () {
      let count = 0
      switch (this.currentTagSearchResultTab) {
        case 'program' :
          count = this.programTagSearchResult.count
          break
        case 'vod' :
          count = this.vodTagSearchResult.count
          break
        case 'movie' :
          count = this.movieTagSearchResult.count
          break
        case 'all' :
          count = this.programTagSearchResult.count + this.vodTagSearchResult.count + this.movieTagSearchResult.count
          break
      }
      return count
    }
  },
  created () {
    window.scrollTo(0, 0)
  }

}
</script>

<style scoped>
  .empty-cell-list {
    position: relative;
    height: 250px;
    width: 100%;
    margin: 0 auto;
    top: 70px;
  }
  .empty-cell-list .attention-mark-area {
    height: 50px;
    width: 50px;
    position: relative;
    margin: 0 auto;
  }
  .empty-cell-list .text-area {
    text-align: center;
    margin-top: 16px;
    color: #a5a5a5;
    font-size: 14px;
    line-height: 20px;
  }
</style>
